export default "__VITE_ASSET__BIf4On7u__"